import { BookingContextType, WidgetSteps } from "../context/BookingContext";

export const exitScreenForStep = (
  step: BookingContextType["currentStep"],
): string => {
  switch (step) {
    case WidgetSteps.SHOW_SUMMARY:
      return "confirmation";
    case WidgetSteps.MESSAGE_COACH:
      return "message_coach";
    default:
      return "time_selection";
  }
};
